import { Link } from 'wouter'

export function BuyButton() {
  return <Link href="/buy">
    <button className="btn btn-small rounded-pill button-gradient me-auto px-4">Buy Credits</button>
  </Link>
}
